export default "__VITE_ASSET__BlmaHt1M__"